import { useEffect, useState } from 'react';
import { config } from '../../features/auth/config';

export interface Service {
  code: string;
  name: string;
  description: string;
  category: string;
  icon: string;
  status: string;
  tier1Price: number;
  tier2Price: number;
  sortOrder: number;
}

export function useServices() {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${config.api.baseUrl}/api/service/list`, {
          headers: {
            [config.auth.headers.frontendKey]: config.auth.headers.frontendKeyValue,
          },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const list: Service[] = json.data?.services || json.data || [];
        if (!cancelled) {
          setServices(list.sort((a, b) => a.sortOrder - b.sortOrder));
          setLoading(false);
        }
      } catch (err: any) {
        if (!cancelled) {
          setError(err.message || 'Failed to load services');
          setLoading(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const startingPrice = services.length > 0
    ? Math.min(...services.map(s => s.tier1Price))
    : null;

  return { services, loading, error, startingPrice };
}
